import React, { createContext, useState } from "react";
import Config from "@skin_config";

const initialState = {
  theme: Config.main.defaultTheme,
};

export const UIContext = createContext();

export const UIContextProvider = ({ children }) => (
  <UIContext.Provider value={useState(initialState)}>
    {children}
  </UIContext.Provider>
);